import color from "../../../constants/color";

const style = {
  headerContainer:{
    display:"flex",
    justifyContent:"space-between",
    alignItems:"center",
    paddingRight:3.5
  }, 
  leaveHeading: { 
    fontWeight: 600,
    fontSize: "20px",
    mb:2 
  },
  numberFormatWrapper: {
    px: "15px",
    mt: 3,
    mb: 4,
  },
  numberFormatCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: "20px",
    padding: "24px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.06)",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    gap: "18px",
  },
  numberFormatTitle: {
    fontSize: "16px",
    fontWeight: 600,
    color: color.text,
  },
  numberFormatSubtitle: {
    fontSize: "13px",
    fontWeight: 400,
    color: color.lightText,
    mt: 0.5,
  },
  numberFormatGrid: {
    mt: 1,
  },
  numberFormatInput: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      fontSize: "14px",
    },
    "& .MuiInputLabel-root": {
      fontSize: "13px",
    },
  },
  numberFormatHint: {
    fontSize: "12px",
    color: color.lightText,
    mt: 1,
  },
  numberFormatActions: {
    display: "flex",
    justifyContent: { xs: "flex-start", md: "flex-end" },
    mt: 2,
    px: "15px",
  },
  numberFormatSave: {
    textTransform: "none",
    borderRadius: "30px",
    px: 3,
  },
  dayText: {
    width: "20%"
  },
  calenderInput:{
    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
    },
    mb:1
  },  
  StartTime:{

  },
  endTime: {
    ml:1
  },
  lunchTime: {
    mr:1,
    width: "20%",
  

  },

  btnGrid: {
    // textAlign: "end",
    justifyContent: "space-around",
    mb:2
  },
  label:{
    fontSize:"12px",
    fontWeight:"500" ,
    color:color.text, 
    my:1
  },
  reason:{
    borderRadius: "18px",
    mr:1,
    mb:3,
    // width:"100%",
    ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input" : {
      py:1
    },
  },
  
  formGrid: {
    display: "flex",
    alignItems: "center"
  },

  dateInput:{
    width: "100%",
    my:1,


    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
    }},

  jobButton: {
    borderRadius: 50, 
    textTransform: "none", 
    backgroundColor: "#28AA4A", 
    fontSize: "12px",
    mt:1,
  },

  inputSection: {
    display:"flex",
    px: 2,
    alignItems: "center",
    
    // mb: 1.5
  },

  inputLabel:{
    fontSize:"12px",
    fontWeight:"500",
    color:color.text
  },
  addIcon: {
    p: 1,
    backgroundColor: "#D4EEDB",
    borderRadius: "5px",
    color: color.primary
  },
  deleteIcon: {
    p: 1,
    pb:0,
    backgroundColor: "#FBD6D6",
    borderRadius: "5px",
    color: color.red

  },

  inputContainer:{
    // width:{xs:"18em",md:"25em",},
    display:"flex",
    flexDirection:"row",
    alignItems:"center",
    justifyContent:"space-between"
  },
  inputContainerBox:{
    // width:{xs:"18em",md:"25em",},
    display:"flex",
    flexDirection:"row",
    alignItems:"center",
    justifyContent:"space-between",
    mb:1,
  },

  modalInput:{
    display:"flex",    // backgroundColor:color.lightGray,
    // width:{ xs: "25em", md: "35em" },
    justifyContent:"center" ,// Center align on smaller screens
    my:"10px",
    height:"2.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input":{
      padding:"5.5px 14px",
    },
    "& .MuiOutlinedInput-root":{
      py: 0.5,
      // mt:1
    },
    width:"100%"
  },


  uploadSection: {
    px: 2,
    width: {xs: "100%", md: "55%"},

    "& .css-2y07vr":{
      py: "7px"

    }
  },
  leaveInputGrid: {
    display: {xs: "block", md: "flex"},
    alignItems: "center",
    justifyContent: "space-between"

  },
  leaveSheetGrid:{
    display: {xs: "block", md: "flex"},
    ml:{xs:0, md:2}, 
    mt:{xs:0, md:2}, 
    height:"fit-content"
  },
  leaveSheet: {
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: "5px",
    px: 1,
    mr: 1,
    mb:{xs:1, md:0},
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    " & .css-0" : {
      display:"flex",

    },
  },
  closeIcon: {
    fontSize: "1rem",
    ml:2,
  },

  inputBox: {
    backgroundColor: color.lightGray,
    borderRadius: "8px",
    py:1,
    px:2,
  },
  inputBoxLoan: {
    backgroundColor: color.lightGray,
    borderRadius: "8px",
    py:1,
    px:2,
    display: "flex",
    mb:2
  },

  inputText: {
    fontSize: "14px",
    fontWeight: "400",
    color: color.text,
  },
  gridbox: {
    backgroundColor: "#ffff",
    m: 2,
    py: 4,
    px:2,
    // mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    height: "fit-content",
    display: "flex",
    flexWrap: "wrap",
    gap:"16px"

  },
  gridboxTime: {
    backgroundColor: "#ffff",
    m: 2,
    py: 4,
    px:2,
    // mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    // display: "flex",
    justifyContent: "end",
    // alignItems: "center"


  },
  weakGrid: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb:1

  },
  weakGrids: {
    display: "flex",
    // justifyContent: "space-between",
    alignItems: "center",
    mb:1

  },
  payslip: {
    display: "flex",
    // justifyContent: "space-between",
    alignItems: "center",
    mb:3,
    gap:10

  },



  formControlLabel: {
    display: "block",
    fontSize: "13px"
  },
  formControlLabels: {
    display: "block",
    fontSize: "14px",
    mt: 4,
  },

  greyLine: {
    border: "1px solid #DEDEDE",
    width: {xs: "20%",md:"75%"},
  },
  greyLineUnit: {
    border: "1px solid #DEDEDE",
    width: {xs: "20%",md:"76%"},
  },
  greyLineDepartment: {
    border: "1px solid #DEDEDE",
    width: "74%",
  },
  greyLinePension: {
    border: "1px solid #DEDEDE",
    width: "74%",
  },
  edit: {
    backgroundColor: "#A3E1FB",
    borderRadius: "8px",
    mx:1,
    display: "flex",
    alignItems: "center",
    width: "27px",
    height: "27px",
    justifyContent: "center",
   
  },
  delete: {
    backgroundColor: color.lightRed,
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    width: "27px",
    height: "27px",
    justifyContent: "center",
   
  },
  dltSection: {
    display: "flex",
    justifyContent:  "end"
  },

  deleteShift: {

    "& svg": {
      width: "20px",
      height: "20px"
    },
    backgroundColor: color.lightRed,
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    width: "37px",
    height: "37px",
    justifyContent: "center",
   
  },


  gridboxs: {
    backgroundColor: "#ffff",
    mt:0,
    mx: 2,
    mb:2,
    py: 4,
    // mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    height: "fit-content",

  },

  itemSection: { 
    display: "flex",
    mx:2,
    alignItems: "center",
    width: "100%",

  },
  gridText: {
    fontSize: "14px",
    fontWeight: "600"
  },
  gridTexts: {
    fontSize: "16px",
    fontWeight: "500"
  },

  bioBox: {
    px: 3,
    pt: 1,
  },
  content: {
    mt: 2,
    ml: 2,
    display:"flex",
    flexDirection:"row",
    // justifyContent:"space-Between"
  },
  switchSection: {
    display: "flex",
    alignItems: "center",
    mb: 1,
  },
  mainBoxes: {
    pr: 2,
    display: "flex",
    justifyContent: "end",
    my:2

  },
  jobButtons: {
    borderRadius: 50, 
    textTransform: "none", 
    backgroundColor: "#28AA4A", 
    fontSize: "14px",
    fontWeight: "500",
    // ml: 3,
    px: 4,
  },
  jobButtonsShift: {
    borderRadius: 50, 
    textTransform: "none", 
    backgroundColor: "#28AA4A", 
    fontSize: "14px",
    fontWeight: "500",
    mr: 2,
    px: 4,
  },
  copyFromInput: {
    width: "100%",
    borderRadius: "8px",
    height: "2.5em",
    // mt: 1,

    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      // padding: "8.5px 14px",
      borderRadius: "8px",
    },
    "& .css-156w56f-MuiInputBase-root-MuiOutlinedInput-root": {
      borderRadius: "8px",
    },
    ".css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper": {
      maxWidth: "25%",
    },
  },

  mainContainer:{
    justifyContent: "end",
    // pr:{xs:1, md:1}
  },
  dropdown:{
    "& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":{
      padding:"8.5px 14px",
    },
    // width:{ xs: "25em", md: "35em" },
    width: "100%",
    fontSize:"14px",
    fontWeight:"400",
    mt:1,
  },
  typeGrid: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    px: "15px",
  },
  popupBox: {
    width: "100%",
  }
}; 
 
export default style;